// extracted by mini-css-extract-plugin
module.exports = {"container":"PageLoading-module--container--3vL46","loading":"PageLoading-module--loading--3b_Gn"};